module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldIt.5f4abac.eot";